module.exports = __webpack_public_path__ + "static/media/Data_insight_en_1-3.4f6f27f0.svg";